import { Box, Button, HStack, Input, Text, VStack } from '@chakra-ui/react';
import dayjs from 'dayjs';
import { useMemo, useState } from 'react';
import { useTranslation } from 'react-i18next';

const WhatsUpBubble = ({ message, onYes, onNo, colors }) => {
    const { t } = useTranslation('chat');
    const [showInput, setShowInput] = useState(false);
    const [phone, setPhone] = useState('');
    const [actionsVisible, setActionsVisible] = useState(true);

    const messageContent = useMemo(() => {
        return message.text.replace('{%WhatsApp_Start}', '');
    }, [message.text]);

    const hideInput = () => {
        setShowInput(false);
        setActionsVisible(false);
    };

    const handleOnYes = () => {
        onYes(phone, hideInput);
    };

    return (
        <Box display="flex" justifyContent="flex-start" px={6} py={2}>
            <VStack gap={1} alignItems="flex-start" maxW="85%">
                <Box
                    bg={colors.botBubble}
                    borderRadius="18px"
                    borderBottomLeftRadius="4px"
                    px={4}
                    py={3}
                    maxW="100%"
                >
                    <Text
                        fontSize="sm"
                        color={colors.textPrimary}
                        whiteSpace="pre-wrap"
                        lineHeight="1.5"
                        mb={3}
                    >
                        {messageContent}
                    </Text>
                    {actionsVisible &&
                        <>
                            {!showInput ? (
                                <HStack gap={2}>
                                    <Button size="sm" colorScheme="green" onClick={() => setShowInput(true)}>{t('whatsapp.yes')}</Button>
                                    <Button size="sm" colorScheme="red" onClick={onNo}>{t('whatsapp.no')}</Button>
                                </HStack>
                            ) : (
                                <VStack gap={2} alignItems="stretch">
                                    <Input
                                        size="sm"
                                        placeholder={t('whatsapp.bubblePhonePlaceholder')}
                                        value={phone}
                                        onChange={e => setPhone(e.target.value)}
                                        bg={colors.inputBg}
                                        color={colors.textPrimary}
                                        borderColor={colors.borderColor}
                                        _placeholder={{ color: colors.dateText }}
                                    />
                                    <HStack gap={2}>
                                        <Button size="sm" colorScheme="green" onClick={handleOnYes}>{t('whatsapp.ok')}</Button>
                                        <Button size="sm" colorScheme="red" onClick={() => {
                                            setShowInput(false);
                                            setPhone('');
                                        }}>{t('whatsapp.cancel')}</Button>
                                    </HStack>
                                </VStack>
                            )}
                        </>
                    }
                </Box>
                <Text fontSize="xs" color={colors.dateText}>
                    {dayjs(message.timestamp).format('HH:mm')}
                </Text>
            </VStack>
        </Box>
    );
};

export default WhatsUpBubble;
